import post from '../../../../../fns/http/post'
import getHeaders from '../headers/index'

const loadProductsByName = (params, data, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.se}/search/lihe-name`, data, params, getHeaders({ locale, headers }), { responseProxy })
}
export default loadProductsByName
